import { CURRENCY } from "../../../consts/general";
import { formatCurrency } from "../../../utilities/general";

export const formatBillingCurrency = (amount) => {
  return formatCurrency(parseFloat(amount) > 0 ? amount : 0, CURRENCY.usd);
};
